import {connect} from "react-redux"
import getSash from "../../utils/getSash"
import State from "../../models/state"
import {getSashAltText} from "../../utils/getSashAltText"
import {LANGUAGE_HEADER} from "../../config/constants"

export const mapStateToProps = (state: State) => {
    const {pageType} = state.request
    const {savingsSashConfig, enableFurtherReductionsSash} = state.productSummary
    const {
        saleSash: saleSashUrl,
        saleSashPosition,
        percentageSavings,
        latestPriceIsSixMonthsOld,
    } = state.productSummary.summaryData
    const language = state.request.headers[LANGUAGE_HEADER] as string
    const sashAltText = getSashAltText(saleSashUrl, state.text.sashAltText)
    const saleSashImageName = getSash(saleSashUrl, language)

    const adjustedPercentageSavings = (() => {
        if (!percentageSavings) return 0
        if (percentageSavings < 60) return 0
        if (percentageSavings >= 60 && percentageSavings < 70) return 60
        return 70
    })()

    return {
        saleSashUrl: saleSashImageName,
        saleSashPosition,
        sashAltText,
        templating: state.template,
        saleOrClearance: pageType,
        percentageSavings: adjustedPercentageSavings,
        shouldShowsSavingsSash: adjustedPercentageSavings / 100 >= savingsSashConfig[pageType],
        shouldShowFurtherReductionsSash: latestPriceIsSixMonthsOld === false && enableFurtherReductionsSash,
    }
}

export default connect(mapStateToProps)
